// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ktvz","placeholdersHeader":"styles_placeholdersHeader__3-f7H","editorStyle":"styles_editorStyle__1xTkM","placeholdersBox":"styles_placeholdersBox__4SpML"};